import ChunkedPaginationUtils from '../../global/chunkedPaginationUtils.js';

const _localCache = new ChunkedPaginationUtils(25, 50);

export const DEFAULT_STATE = {
    results: [],
    total: 0,
    canLoadMore: false,
    needsToRequest: false,
    pageNumber: 0,
    pageSize: _localCache.getPageSize(),
};

export default function (state = DEFAULT_STATE, action) {
    switch (action.type) {
        case 'MinistryQuickviewActions.ON_RESET':
            return DEFAULT_STATE;

        case 'MinistryQuickviewActions.ON_SEARCH':
            _localCache.loadPage(action.result.locations, action.result.total, action.callbackParams.first);
            return {
                results: _localCache.getAll(true),
                total: _localCache.getTotalCount(),
                canLoadMore: _localCache.canLoadMore(),
                needsToRequest: _localCache.needsToLoadPage(),
                pageNumber: _localCache.getCurrentPageNumber(),
                pageSize: _localCache.getPageSize(),
            };

        case 'MinistryQuickviewActions.ON_NEXTPAGE':
            return {
                results: _localCache.getAll(true),
                total: _localCache.getTotalCount(),
                canLoadMore: _localCache.canLoadMore(),
                needsToRequest: _localCache.needsToLoadPage(),
                pageNumber: _localCache.getCurrentPageNumber(),
                pageSize: _localCache.getPageSize(),
            };
    }
    return state;
}
